/**
 * @graphql cc
 */
import gql from 'graphql-tag';

export const ExternalByLineQuery = gql`
	query ExternalByLineQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			type
			history {
				createdDate
				createdBy {
					type
					displayName
					... on KnownUser {
						accountId
					}
				}
				ownedBy {
					type
					displayName
					... on KnownUser {
						accountId
					}
				}
				lastOwnedBy {
					type
					displayName
					... on KnownUser {
						accountId
					}
				}
			}
			version {
				by {
					type
					displayName
					... on KnownUser {
						accountId
					}
				}
				friendlyWhen
				number
				confRev
				syncRev
				contentTypeModified
			}
		}
	}
`;
